import { useState } from 'react';
import { FaCheck, FaTrashAlt, FaExclamationTriangle, FaInfoCircle, FaArchive, FaShieldAlt } from 'react-icons/fa';

const BLOCK = 'LStudio__app_confirm';

export const CONFIRM_TONES = ['danger', 'warning', 'info', 'success'];

const TONE_ICON = {
    danger: FaTrashAlt,
    warning: FaExclamationTriangle,
    info: FaInfoCircle,
    success: FaCheck,
    archive: FaArchive,
    security: FaShieldAlt,
};

const matchesInput = (value, input) => {
    if (!input) return true;
    const text = String(value ?? '').trim();
    if (input.required !== false && !text) return false;
    if (input.length && text.length !== Number(input.length)) return false;
    if (input.pattern) {
        try { return new RegExp(input.pattern).test(text); }
        catch { return true; }
    }
    return true;
};

export const ConfirmBody = ({
    tone = 'danger',
    icon = null,
    title = '\u00bfConfirmas la accion?',
    text = '',
    html = '',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    requireText = null,
    requireLabel = 'Para confirmar, escribi exactamente:',
    input = null,
    onConfirm,
    onCancel,
}) => {
    const [useTyped, setTyped] = useState('');
    const [useInput, setInput] = useState('');
    const Icon = TONE_ICON[icon ?? tone] ?? FaInfoCircle;

    const IS_REQUIRE_LOCKED = !!requireText && useTyped.trim() !== String(requireText).trim();
    const IS_INPUT_LOCKED = !!input && !matchesInput(useInput, input);
    const IS_LOCKED = IS_REQUIRE_LOCKED || IS_INPUT_LOCKED;

    return (
        <div className={BLOCK} data-tone={tone} role="alertdialog" aria-modal="true">
            <div className={`${BLOCK}__icon`}><Icon /></div>
            <h2 className={`${BLOCK}__title`}>{title}</h2>
            {text && <p className={`${BLOCK}__text`}>{text}</p>}
            {html && <div className={`${BLOCK}__text`} dangerouslySetInnerHTML={{ __html: html }} />}

            {input && (
                <div className={`${BLOCK}__require ${BLOCK}__require--security`}>
                    <label className={`${BLOCK}__require_label`} htmlFor="LStudio__confirm_secure_input">
                        {input.label || 'Codigo de seguridad'}
                    </label>
                    {input.hint && <small className={`${BLOCK}__input_hint`}>{input.hint}</small>}
                    <input id="LStudio__confirm_secure_input"
                        type={input.type || 'text'} inputMode={input.inputMode || 'numeric'}
                        autoComplete={input.autoComplete || 'one-time-code'}
                        maxLength={input.maxLength || input.length || undefined}
                        className={`${BLOCK}__require_input ${BLOCK}__require_input--security`}
                        placeholder={input.placeholder || '123456'}
                        value={useInput}
                        onChange={(event) => setInput(input.numeric ? event.target.value.replace(/\D/g, '') : event.target.value)}
                        autoFocus />
                </div>
            )}

            {requireText && (
                <div className={`${BLOCK}__require`}>
                    <label className={`${BLOCK}__require_label`} htmlFor="LStudio__confirm_require_input">
                        {requireLabel} <code className={`${BLOCK}__require_token`}>{requireText}</code>
                    </label>
                    <input id="LStudio__confirm_require_input" type="text" autoComplete="off"
                        className={`${BLOCK}__require_input`}
                        placeholder="Escribi aca para habilitar el boton"
                        value={useTyped} onChange={(event) => setTyped(event.target.value)} />
                </div>
            )}

            <div className={`${BLOCK}__actions`}>
                <button type="button" className={`${BLOCK}__button ${BLOCK}__button--cancel`} onClick={onCancel}>
                    {cancelText}
                </button>
                <button type="button" className={`${BLOCK}__button ${BLOCK}__button--confirm`}
                    onClick={() => onConfirm(input ? useInput.trim() : true)} disabled={IS_LOCKED} autoFocus={!requireText && !input}>
                    {confirmText}
                </button>
            </div>
        </div>
    );
};
